module.exports = __webpack_public_path__ + "static/media/angelo-pantazis.4d4ad915.jpg";